<template>
    <div style="height: 100%">
        <div class="images-overlay-modal">
            <div class="images-container">
                <div class="image-div">
                    <div class="image-text">
                        <span>{{ $translate('pn') }}</span>
                        <template v-if="hasPN">
                            <span class="colon">:</span>
                            <span>{{ pnHour }}</span>
                        </template>
                    </div>
                    <div v-if="hasPN" class="image-container">
                        <img
                            v-show="imagesLoadingMap[pnImageUrl]"
                            :src="pnImageUrl"
                            alt=""
                            @load="loaded(pnImageUrl)"
                        />
                        <well-graphical-segmentations
                            v-if="hasSegmentations"
                            class="w-100 h-100 rounded-top-lg segmentations"
                            :segmentations="segmentations"
                            :current-run-index="pnRunIndex"
                            always-show
                        />
                        <div v-if="!imagesLoadingMap[pnImageUrl]" class="event-unavailable-overlay">
                            <b-spinner class="video-spinner" variant="primary" />
                        </div>
                    </div>
                    <div v-else class="event-unavailable-overlay">
                        <span>{{ $translate('na') }}</span>
                    </div>
                </div>

                <div v-for="event in events" :key="event.systemName" class="image-div">
                    <div class="image-text">
                        <span>{{ $translate(event.systemName) }}</span>
                        <span class="colon">:</span>
                        <span>{{ event.value }}H</span>
                    </div>
                    <div class="image-container">
                        <img
                            v-show="imagesLoadingMap[event.imageUrl]"
                            :src="event.imageUrl"
                            alt=""
                            @load="loaded(event.imageUrl)"
                        />
                        <div
                            v-if="!imagesLoadingMap[event.imageUrl]"
                            class="event-unavailable-overlay"
                        >
                            <b-spinner class="video-spinner" variant="primary" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Utils from '../../../business/utils/Utils'
import { mapGetters } from 'vuex'
import WellGraphicalSegmentations from '../WellGraphicalSegmentations'

export default {
    name: 'ImagesOverlayModal',
    components: {
        WellGraphicalSegmentations
    },
    props: {
        well: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            imagesLoadingMap: {}
        }
    },
    computed: {
        ...mapGetters({
            getPnCount: 'timelapse/getPnCount',
            getPnCountTime: 'timelapse/getPnCountTime'
        }),
        segmentations() {
            return this.well.inferenceData.segmentations
        },
        events() {
            return Utils.getMkEventsWithImagesForAnnotationOverlay(this.well)
        },
        pnCount() {
            return this.getPnCount(this.well)
        },
        pnCountTime() {
            const countTime = this.getPnCountTime(this.well)
            return countTime ? parseFloat(countTime) : 0.0
        },
        pnRunIndex() {
            return this.well.runs.findLastIndex(({ time }) => time == this.pnCountTime.toFixed(2))
        },
        hasPN() {
            return this.pnCount && this.pnCount > 0 && this.pnCountTime
        },
        pnHour() {
            return this.pnCountTime ? `${this.pnCountTime.toFixed(2)}H` : null
        },
        pnImageUrl() {
            if (!this.hasPN) return null

            const { videoFramesTime = [] } = this.well
            if (this.pnRunIndex >= 0 && this.pnRunIndex < videoFramesTime.length) {
                return Utils.getImageUrlFromTime(this.well, videoFramesTime[this.pnRunIndex])
            }
            return null
        },
        hasSegmentations() {
            // todo: remove below line when treatments api return segmentations
            return false
            // return this.segmentations && this.segmentations.length
        }
    },
    methods: {
        loaded(url) {
            this.imagesLoadingMap = { ...this.imagesLoadingMap, [url]: true }
        }
    }
}
</script>

<style lang="scss" scoped>
.images-overlay-modal {
    .images-container {
        display: grid;
        gap: 2rem;
        width: 100%;

        .image-div {
            display: flex;
            flex-direction: column;

            .image-text {
                margin-bottom: 0.5rem;
                .colon {
                    margin: 0 0.25rem;
                }
            }
            .image-container {
                width: 100%;
                position: relative;

                &:hover {
                    border: 1px solid gray;
                }
                img {
                    width: 100%;
                    max-width: 100%;
                }
                .segmentations {
                    z-index: 99999;
                }
            }
        }

        .event-unavailable-overlay {
            aspect-ratio: 1/1;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 24px;
            font-weight: 600;
            background-color: $dark-4;
            opacity: 0.8;
            pointer-events: none;
        }

        @media screen and #{$new-break1} {
            grid-template-columns: 1fr;
        }
        @media screen and #{$new-break2} {
            grid-template-columns: repeat(2, 1fr);
        }
        @media screen and #{$new-break3} {
            grid-template-columns: repeat(3, 1fr);
        }
        @media screen and #{$new-break4open} {
            grid-template-columns: repeat(4, 1fr);
        }
    }
}
</style>

<style lang="scss">
.images-overlay-b-modal {
    padding-left: 0 !important;

    button.close {
        font-size: 2.5rem;
        padding: 0.6rem;
        font-weight: normal;
        opacity: 1;
    }
    .modal-dialog {
        width: 100%;
    }
    .modal-body {
        padding: 1rem;
    }
    .id-text {
        font-size: 1rem;
        color: $light;
    }

    .video-spinner {
        font-size: 1rem;
    }
}
</style>
